import { Traveler } from '@marageti/z4-sdk/lib/people';
import React from 'react';
import Form from './form';

type MyProfileFormViewProps = {
  isLoading: boolean,
  isError: boolean,
  traveler: Traveler | undefined,
  submissionError: boolean,
  handleSubmit: (data: any) => void
  onCancel: () => void
};

const MyProfileFormView = ({
  isLoading,
  isError,
  traveler,
  submissionError,
  handleSubmit,
  onCancel,
}:MyProfileFormViewProps) => {
  if (!traveler || isLoading) {
    return null;
  }

  if (isError) {
    return null;
  }

  return (
    <Form
      defaultValues={{
        givenName: traveler.givenName,
        familyName: traveler.familyName,
        phone: traveler.phone,
        countryOfResidence: traveler.countryOfResidence,
        timeZone: traveler.timeZone,
      }}
      submissionError={submissionError}
      onSubmit={handleSubmit}
      onCancel={onCancel}
    />
  );
};

export default MyProfileFormView;
